export const DEFAULT_REDIRECT_PATH = '/dashboard'

// Same-origin paths only: never protocol-relative (`//`, `/\`) or absolute.
export const isSafeRedirectPath = (path) =>
  typeof path === 'string' && path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\')

export const getSafeRedirectPath = (path) => isSafeRedirectPath(path) ? path : DEFAULT_REDIRECT_PATH
